import {
    Component,
    OnInit,
    ViewChild,
    TemplateRef,
    HostListener,
    Input,
    Output,
    EventEmitter,
    Inject,
    Optional
} from '@angular/core';
import { isString, cloneDeep, forEach, find, indexOf } from 'lodash';
import { PlatfromUserAccssManagementService } from '../../services/platform-user-access-management.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CreateUserCommand } from '../../models/platform-user-access-management.model';
import { IUamConfig } from '../../interfaces/platform-user-access-management.interface';
import { Subscription } from 'rxjs';
import { AppPlatformDataTableComponent, DatatableModel } from '../../../app-platform-datatable';

@Component({
    selector: 'app-platform-user-access-management-view',
    templateUrl: './platform-user-access-management.component.html',
    styleUrls: ['./platform-user-access-management.component.scss'],
    standalone: false
})
export class AppPlatformUserAccessManagementComponent<T> implements OnInit {
    @Input() headerTemplate: TemplateRef<any>;
    @Input() uamConfig: IUamConfig;
    @Output() OnClickCreateUser = new EventEmitter<any>();
    @Output() OnClickDataTableRow = new EventEmitter<any>();
    @ViewChild(AppPlatformDataTableComponent, { static: true }) datatable: AppPlatformDataTableComponent<T>;
    datatableModel: DatatableModel<T> = new DatatableModel<T>(undefined);
    requestData: any;
    headerlangKey: any;
    createButtonLangKey: any;
    filterByLangKey: any;
    tableModel: any;
    searchKey: any;
    dataList: any[] = [];
    loading: boolean = false;
    innerWidth: any;
    isItExtraSmall: boolean = false;
    seletedSearchBy: any;
    searchByList: any[] = [];
    enableSearchUser: boolean = false;
    enableFilterByRole: boolean = false;
    enableToCreateUser: boolean = false;
    userRolesFilter: any[] = [];
    seletedFilterRole: any;
    customPayload: any;
    uamViews: any;
    OnGetCustomUserListSubscription: Subscription;
    OnPayloadUpdateSubscription: Subscription;
    defaultSearchBy: any = [
        {
            Icon: 'people',
            Label: 'DisplayName',
            PlaceHolder: 'search displayname',
            PropertyName: 'DisplayName'
        }
    ];
    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.innerWidth = window.innerWidth;
        this.isItExtraSmall = false;
        if (this.innerWidth < 600) {
            this.isItExtraSmall = true;
        }
    }

    constructor(
        private platfromUserAccssManagementService: PlatfromUserAccssManagementService,
        @Optional() @Inject('IAppPlatformUserAccessManagement') private IAppPlatformUserAccessManagement,
        private router: Router,
        public snackBar: MatSnackBar
    ) {}

    ngOnInit(): void {
        this.uamViews = this.platfromUserAccssManagementService.getViews();
        this.innerWidth = window.innerWidth;
        if (this.innerWidth < 600) {
            this.isItExtraSmall = true;
        }
        this.searchKey = '';
        this.customPayload = {};
        this.platfromUserAccssManagementService.subscribeSubscription();
        // this.headerlangKey = this.uamConfig && this.uamConfig.HeaderTitleLangKey || "USER_LIST_TITLE";
        // this.createButtonLangKey = this.uamConfig && this.uamConfig.CreateButtonTextLangKey || 'CREATE_BUTTTON_TEXT';
        // this.filterByLangKey = this.uamConfig && this.uamConfig.FilterByLangKey || 'FILTER_BY';
        this.requestData = {
            PageNumber:
                (this.uamConfig && this.uamConfig.RequestFilter && this.uamConfig.RequestFilter.PageNumber) || 0,
            PageLimit: (this.uamConfig && this.uamConfig.RequestFilter && this.uamConfig.RequestFilter.PageLimit) || 10,
            OrderBy:
                (this.uamConfig && this.uamConfig.RequestFilter && this.uamConfig.RequestFilter.OrderBy) ||
                'CreateDate',
            SortOrder:
                (this.uamConfig && this.uamConfig.RequestFilter && this.uamConfig.RequestFilter.SortOrder) ||
                'Descending',
            SearchFilters:
                (this.uamConfig && this.uamConfig.RequestFilter && this.uamConfig.RequestFilter.SearchFilters) || {}
        };
        this.requestData.PropertyFromPerson = (this.uamConfig && this.uamConfig.PropertyFromPerson) || [];
        // this.enableToCreateUser = this.uamConfig && this.uamConfig.EnableCreateNewUser;

        // this.enableSearchUser = this.uamConfig && this.uamConfig.EnableSearch;
        // if (this.enableSearchUser) {
        //     this.searchByList = this.uamConfig && this.uamConfig.SeachByList || this.defaultSearchBy;
        //     this.seletedSearchBy = this.searchByList && this.searchByList[0];
        // }

        // this.enableFilterByRole = this.uamConfig && this.uamConfig.EnableFilterByRole;
        // if (this.enableFilterByRole) {
        //     this.getFilterRoles();
        // }
        this.setDataTableModelSettings();
        this.platfromUserAccssManagementService.onUserUpdated.subscribe(response => {
            if (response) {
                this.getTableData(this.tableModel);
            }
        });
        this.platfromUserAccssManagementService.OnUserCreated.subscribe(response => {
            if (response) {
                this.getTableData(this.tableModel);
            }
        });
        this.platfromUserAccssManagementService.OnUserDeleted.subscribe(response => {
            if (response) {
                this.getTableData(this.tableModel);
            }
        });

        this.OnPayloadUpdateSubscription = this.platfromUserAccssManagementService.OnPayloadUpdate.subscribe(
            payload => {
                if (payload) {
                    this.searchKey = payload.searchKey;
                    this.seletedSearchBy = {};
                    this.seletedSearchBy.PropertyName = payload.seletedSearchBy;
                    this.onPayloadUpdate(payload);
                }
            }
        );
        this.OnGetCustomUserListSubscription = this.platfromUserAccssManagementService.OnGetCustomUserList.subscribe(
            payload => {
                if (payload) {
                    this.OnGetCustomUserList(payload);
                }
            }
        );

        // this.platfromUserAccssManagementService.ToResendActivationEmail.subscribe(response=>{
        //     if(response){
        //         this.resendActivationEmail();
        //     }
        // })
    }
    setDataTableModelSettings() {
        this.datatableModel = {
            TotalElements:
                (this.uamConfig && this.uamConfig.DatatableModel && this.uamConfig.DatatableModel.TotalElements) || 0,
            TotalPages:
                (this.uamConfig && this.uamConfig.DatatableModel && this.uamConfig.DatatableModel.TotalPages) || 3,
            Data: (this.uamConfig && this.uamConfig.DatatableModel && this.uamConfig.DatatableModel.Data) || [],
            SortBy:
                (this.uamConfig && this.uamConfig.DatatableModel && this.uamConfig.DatatableModel.SortBy) ||
                'CreateDate',
            SortDir: (this.uamConfig && this.uamConfig.DatatableModel && this.uamConfig.DatatableModel.SortDir) || null,
            PageSize: (this.uamConfig && this.uamConfig.DatatableModel && this.uamConfig.DatatableModel.PageSize) || 10,
            CurrentPageNumber:
                (this.uamConfig && this.uamConfig.DatatableModel && this.uamConfig.DatatableModel.CurrentPageNumber) ||
                0
        };
        this.datatable.columns = this.uamConfig && this.uamConfig.Datatable && this.uamConfig.Datatable.Columns;
        this.datatable.messages = {
            emptyMessage:
                (this.uamConfig && this.uamConfig.Datatable && this.uamConfig.Datatable.EmptyMessage) ||
                'No data to display',
            totalMessage:
                (this.uamConfig && this.uamConfig.Datatable && this.uamConfig.Datatable.TotalMessage) || ' Item(s)'
        };
    }

    onPayloadUpdate(payload) {
        if (this.uamConfig && this.uamConfig.LoadBusinessSpecificUsers) {
            this.IAppPlatformUserAccessManagement.getBusinessSpecificUserList(
                payload.searchKey,
                payload.seletedSearchBy,
                cloneDeep(payload.requestData)
            ).subscribe((response: any = {}) => {
                if (this.uamConfig && this.uamConfig.needExtraUserInfo) {
                    this.IAppPlatformUserAccessManagement.getUpdatedUserInfo(
                        response && response['Users'],
                        this.uamConfig && this.uamConfig.callback
                    ).subscribe(responseUpdatedUser => {
                        response['Users'] = responseUpdatedUser;
                        this.setUserListOnDataTable(response);
                        this.loading = false;
                    });
                } else {
                    this.setUserListOnDataTable(response);
                    this.loading = false;
                }
            });
        } else {
            this.platfromUserAccssManagementService
                .getUserList(payload.searchKey, payload.seletedSearchBy, cloneDeep(payload.requestData))
                .subscribe(response => {
                    if (this.uamConfig && this.uamConfig.needExtraUserInfo) {
                        this.IAppPlatformUserAccessManagement.getUpdatedUserInfo(
                            response && response['Users'],
                            this.uamConfig && this.uamConfig.callback
                        ).subscribe(responseUpdatedUser => {
                            response['Users'] = responseUpdatedUser;
                            this.setUserListOnDataTable(response);
                            this.loading = false;
                        });
                    } else {
                        this.setUserListOnDataTable(response);
                        this.loading = false;
                    }
                });
        }
    }

    OnGetCustomUserList(customPayload) {
        this.customPayload = customPayload && customPayload.payload;
        this.searchKey = (customPayload && customPayload.searchKey) || this.searchKey;
        this.requestData.PageNumber = Number.isInteger(
            customPayload && customPayload.requestData && customPayload.requestData.PageNumber
        )
            ? customPayload.requestData.PageNumber
            : this.requestData.PageNumber;
        this.requestData.PageLimit = Number.isInteger(
            customPayload && customPayload.requestData && customPayload.requestData.PageLimit
        )
            ? customPayload.requestData.PageLimit
            : this.requestData.PageLimit;
        if (this.uamConfig && this.uamConfig.LoadBusinessSpecificUsers) {
            this.IAppPlatformUserAccessManagement.getBusinessSpecificUserList(
                this.searchKey,
                this.seletedSearchBy && this.seletedSearchBy.PropertyName,
                cloneDeep(this.requestData),
                this.customPayload
            ).subscribe((response: any = {}) => {
                if (this.uamConfig && this.uamConfig.needExtraUserInfo) {
                    this.IAppPlatformUserAccessManagement.getUpdatedUserInfo(
                        response && response['Users'],
                        this.uamConfig && this.uamConfig.callback
                    ).subscribe(responseUpdatedUser => {
                        response['Users'] = responseUpdatedUser;
                        this.setUserListOnDataTable(response);
                        this.loading = false;
                    });
                } else {
                    this.setUserListOnDataTable(response);
                    this.loading = false;
                }
            });
        } else {
            this.getCustomUserList();
        }
    }
    getCustomUserList() {
        this.IAppPlatformUserAccessManagement.getCustomUserList(
            this.searchKey,
            this.seletedSearchBy && this.seletedSearchBy.PropertyName,
            cloneDeep(this.requestData),
            this.customPayload
        ).subscribe(response => {
            if (this.uamConfig && this.uamConfig.getCustomUserList) {
                this.IAppPlatformUserAccessManagement.getFilteredUserInfoForCustomUserList(
                    response,
                    this.uamConfig
                ).subscribe(responseUpdatedUser => {
                    response['Users'] = responseUpdatedUser;
                    this.setUserListOnDataTable(response);
                    this.loading = false;
                });
            } else {
                this.setUserListOnDataTable(response);
                this.loading = false;
            }
        });
    }
    updateRequestData(tableModel) {
        this.tableModel = tableModel;
        this.requestData.PageNumber = tableModel && tableModel.CurrentPageNumber;
        this.requestData.PageLimit = tableModel && tableModel.PageSize;
        this.requestData.OrderBy = (tableModel && tableModel.SortBy) || this.datatableModel.SortBy;
        this.requestData.SortOrder =
            tableModel && !tableModel.SortDir
                ? this.requestData.SortOrder
                : tableModel.SortDir === 'asc'
                  ? 'Ascending'
                  : 'Descending';
    }

    fetchDataRequired(tableModel: DatatableModel<T>) {
        if (this.uamConfig && this.uamConfig.LoadBusinessSpecificUsers) {
            this.updateRequestData(tableModel);
            this.getBusinessSpecificUserList();
        } else if (this.uamConfig && this.uamConfig.getCustomUserList) {
            this.updateRequestData(tableModel);
            this.getCustomUserList();
        } else {
            this.getTableData(tableModel);
        }
    }
    selectData(dataTableRow: T) {
        if (this.uamConfig && this.uamConfig.EnableUpdateuser) {
            this.updateUser(dataTableRow);
        }
    }
    getBusinessSpecificUserList() {
        this.loading = true;
        this.IAppPlatformUserAccessManagement.getBusinessSpecificUserList(
            this.searchKey,
            this.seletedSearchBy && this.seletedSearchBy.PropertyName,
            this.requestData,
            this.customPayload
        ).subscribe((response: any = {}) => {
            if (this.uamConfig && this.uamConfig.needExtraUserInfo) {
                this.IAppPlatformUserAccessManagement.getUpdatedUserInfo(
                    response && response['Users'],
                    this.uamConfig && this.uamConfig.callback
                ).subscribe(responseUpdatedUser => {
                    response['Users'] = responseUpdatedUser;
                    this.setUserListOnDataTable(response);
                    this.loading = false;
                });
            } else {
                this.setUserListOnDataTable(response);
                this.loading = false;
            }
        });
    }

    getTableData(tableModel) {
        this.tableModel = tableModel;
        this.requestData.PageNumber = tableModel && tableModel.CurrentPageNumber;
        this.requestData.PageLimit = tableModel && tableModel.PageSize;
        this.requestData.OrderBy = (tableModel && tableModel.SortBy) || this.datatableModel.SortBy;
        this.requestData.SortOrder =
            tableModel && !tableModel.SortDir
                ? this.requestData.SortOrder
                : tableModel.SortDir === 'asc'
                  ? 'Ascending'
                  : 'Descending';
        this.requestData.SearchFilters =
            (this.uamConfig && this.uamConfig.RequestFilter && this.uamConfig.RequestFilter.SearchFilters) || {};

        this.loading = true;
        this.platfromUserAccssManagementService
            .getUserList(this.searchKey, this.seletedSearchBy && this.seletedSearchBy.PropertyName, this.requestData)
            .subscribe((response: any = {}) => {
                if (this.uamConfig && this.uamConfig.needExtraUserInfo) {
                    this.IAppPlatformUserAccessManagement.getUpdatedUserInfo(
                        response && response['Users'],
                        this.uamConfig && this.uamConfig.callback
                    ).subscribe(responseUpdatedUser => {
                        response['Users'] = responseUpdatedUser;
                        this.setUserListOnDataTable(response);
                        this.loading = false;
                    });
                } else {
                    this.setUserListOnDataTable(response);
                    this.loading = false;
                }
            });
    }
    setUserListOnDataTable(response) {
        this.datatableModel = {
            PageSize: this.tableModel.PageSize || 10,
            TotalElements: response && response['TotalCount'] ? response['TotalCount'] : 0,
            TotalPages: response && response['TotalPages'] ? response['TotalPages'] : 3,
            CurrentPageNumber: Number.isInteger(this.requestData && this.requestData.PageNumber)
                ? this.requestData.PageNumber
                : this.tableModel.CurrentPageNumber,
            SortBy: this.tableModel.SortBy,
            SortDir: this.tableModel.SortDir,
            Data: response ? response['Users'] : []
        };
    }
    resendActivationEmail(userId) {
        this.platfromUserAccssManagementService.resendActivationEmail(userId).subscribe(response => {
            this.openSnackBar('');
        });
    }
    private openSnackBar(message: string) {
        this.snackBar.open(message, null, {
            duration: 2000
        });
    }
    /* Search */
    setSelectSearchBy(searchBy) {
        this.resetSearchFilterOfRequestData();
        this.seletedSearchBy = searchBy;
    }
    resetSearchFilterOfRequestData() {
        delete this.requestData.SearchFilters[this.seletedSearchBy && this.seletedSearchBy.PropertyName];
        if (!this.seletedFilterRole) delete this.requestData.SearchFilters['Roles'];
        Object.assign(
            this.requestData.SearchFilters,
            (this.uamConfig && this.uamConfig.RequestFilter && this.uamConfig.RequestFilter.SearchFilters) || {}
        );
    }
    getResultForSearchKey(ev) {
        if (this.searchKey && isString(this.searchKey)) {
            this.requestData.PageNumber = 0;
            this.resetSearchFilterOfRequestData();
            this.platfromUserAccssManagementService
                .getUserList(
                    this.searchKey,
                    this.seletedSearchBy && this.seletedSearchBy.PropertyName,
                    cloneDeep(this.requestData)
                )
                .subscribe(response => {
                    this.setUserListOnDataTable(response);
                });
        } else if (this.searchKey == '') {
            this.clearSearchKey();
        }
    }
    clearSearchKey() {
        if (!this.searchKey) {
            this.searchKey = '';
            this.resetSearchFilterOfRequestData();
            this.getTableData(this.tableModel);
        }
    }
    searchFieldCloseIconClick() {
        this.searchKey = '';
        this.resetSearchFilterOfRequestData();
        this.getTableData(this.tableModel);
    }
    /* Search End*/

    /* Filter */
    getFilterRoles() {
        this.platfromUserAccssManagementService
            .getUsersRoles(this.uamConfig && this.uamConfig.RolesFilter)
            .subscribe(response => {
                this.userRolesFilter = this.getRolesWithValues(response && response.Roles);
                this.setDefaultRole();
            });
    }

    setDefaultRole() {
        if (this.enableFilterByRole && this.uamConfig && this.uamConfig.DefaultSelectedRole) {
            this.seletedFilterRole = find(this.userRolesFilter, this.uamConfig && this.uamConfig.DefaultSelectedRole);
        }
    }
    getRolesWithValues(roles) {
        let roleList = [];
        forEach(roles, role => {
            forEach(this.uamConfig && this.uamConfig.RolesFilter, filter => {
                if (this.isAvailable(filter, role)) {
                    roleList.push({
                        Value: (filter && filter.ReplacedValue) || (role && role.RoleName),
                        Role: role && role.RoleName
                    });
                }
            });
        });
        if (this.uamConfig && this.uamConfig.ExtraRolesOfFilter && this.uamConfig.ExtraRolesOfFilter.length) {
            forEach(this.uamConfig.ExtraRolesOfFilter, role => {
                roleList.unshift(role);
            });
        }
        return roleList;
    }

    isAvailable(filter, role) {
        return indexOf(role && role.Tags, filter.Tag) > -1 ? true : false;
    }

    onSelectionChange(role) {
        this.seletedFilterRole = role && role.value;
        if (this.requestData.SearchFilters && this.seletedFilterRole) {
            this.resetSearchFilterOfRequestData();
            this.requestData.SearchFilters['Roles'] =
                this.seletedFilterRole && this.seletedFilterRole.Role ? [this.seletedFilterRole.Role] : undefined;
        }
        this.getTableData(this.tableModel);
    }
    /* Filter End */

    /* Create user */

    createUser() {
        if (this.uamConfig && this.uamConfig.CustomCreateUser) {
            let userModel = new CreateUserCommand();
            this.platfromUserAccssManagementService.OnCreateUser(userModel);
            // this.OnClickCreateUser.emit(userModel);
        } else {
            this.platfromUserAccssManagementService.updateRoute(this.uamViews.createUser, null);
            // let createUserId = this.ecapCorGuidGeneratorService.getNewGuid();
            //    let componentName = this.uamConfig && this.uamConfig.RefCreateNewUserComponent ? this.getUrlComponent(this.uamConfig && this.uamConfig.RefCreateNewUserComponent) : 'DEFAULT';
            // this.router.navigate([location.pathname, 'new'],{
            //     queryParams: {
            //         root: location.pathname
            //     }
            // });
        }
    }

    getUrlComponent(componentName) {
        return componentName;
        // return this.CamelcaseToWord(componentName).trim();
    }
    CamelcaseToWord(string) {
        return string.replace(/([A-Z])/g, $1 => {
            return '-' + $1.toLowerCase();
        });
    }

    /* Create user End*/

    /* Update user */
    updateUser(dataTableRow) {
        if (this.uamConfig && this.uamConfig.CustomUpdateUser) {
            // let userInfo = new UpdateUserCommand(dataTableRow);
            this.platfromUserAccssManagementService.OnUpdateUser(dataTableRow);
            // this.OnClickDataTableRow.emit(dataTableRow);
        } else {
            this.platfromUserAccssManagementService.updateRoute(
                this.uamViews.editUser,
                dataTableRow && dataTableRow.ItemId
            );

            // let updatedUserId = dataTableRow && dataTableRow.ItemId;
            //  let componentName = this.uamConfig && this.uamConfig.RefUpdateUserComponent ? this.getUrlComponent(this.uamConfig && this.uamConfig.RefUpdateUserComponent) : 'DEFAULT';
            // this.router.navigate([location.pathname, updatedUserId,  'update'],{
            //     queryParams: {
            //         root: location.pathname
            //     }
            // });
        }
    }

    /* Update User End */

    ngOnDestroy() {
        this.customPayload = {};
        this.OnGetCustomUserListSubscription && this.OnGetCustomUserListSubscription.unsubscribe();
        this.OnPayloadUpdateSubscription && this.OnPayloadUpdateSubscription.unsubscribe();
        this.platfromUserAccssManagementService.unsubscribeSubscriptions();
    }
}
